export class SimulatorState {
  nonRelevantDataElementIds: string[] = [];
  endPointId = '';
  selectedDecisionPointId = '';
  selectedDecisionPointLabel = '';
  selectedBranchLabel = '';

}
